import { render, staticRenderFns } from "./jxcAccount.vue?vue&type=template&id=0dc95aca&scoped=true&"
import script from "./jxcAccount.vue?vue&type=script&lang=js&"
export * from "./jxcAccount.vue?vue&type=script&lang=js&"
import style0 from "./jxcAccount.vue?vue&type=style&index=0&id=0dc95aca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc95aca",
  null
  
)

export default component.exports